import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router'
import { ErrorBoundary } from 'react-error-boundary'

import ProjectDetails from '@/components/ProjectDetails'
import ProjectForm from '@/components/ProjectForm'
import AppLayout from '@/components/AppLayout'
import PortalForm from '@/components/PortalForm'
import { ToasterProvider } from '@/components/shared/ToasterProvider'
import AppCrashFallback from '@/components/shared/AppCrashFallback'
import PortalsList from '@/components/PortalsList'
import PortalDetails from '@/components/PortalDetails'
import { initGA, identifyUser } from '@/utils/analytics'
import store from '@/store/store'
import { Provider } from 'react-redux'
import ProjectListProvider from '@/components/ProjectListProvider'
import { useGetCurrentUserQuery } from '@/features/apiSliceWithCurrentUser'

function RequireAuth() {
  const { data: currentUser, isFetching } = useGetCurrentUserQuery()
  if (isFetching) return null
  if (!currentUser) return window.location.href = '/users/sign_in'

  identifyUser(currentUser)
  return <Outlet />
}

initGA()

export default function App() {
  return (
    <ErrorBoundary FallbackComponent={AppCrashFallback}>
      <ToasterProvider>
        <Provider store={store}>
          <BrowserRouter>
            <Routes>
              // redirect any unmatched routes to /projects
              <Route path="/" element={<Navigate to="/projects" replace />} />
              <Route element={<RequireAuth />}>
                <Route path="projects" element={<AppLayout />}>
                  <Route index element={<ProjectListProvider />} />
                  <Route path=":projectId" element={<ProjectDetails />} />
                  <Route path="new" element={<ProjectForm key="new" />} />
                  <Route path=":projectId/edit" element={<ProjectForm key="edit" />} />
                </Route>
                <Route path="portals" element={<AppLayout />}>
                  <Route index element={<PortalsList />} />
                  <Route path="new" element={<PortalForm key="new" />} />
                  <Route path=":portalSlug" element={<PortalDetails />} />
                  <Route path=":portalSlug/:tab" element={<PortalDetails />} />
                  <Route path=":portalSlug/edit" element={<PortalForm key="edit" />} />
                </Route>
              </Route>

              // Public portal show - no auth required, matched last to avoid conflicts
              <Route path=":portalSlug" element={<AppLayout />}>
                <Route index element={<PortalDetails />} />
                <Route path=":tab" element={<PortalDetails />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </Provider>
      </ToasterProvider>
    </ErrorBoundary>
  )
}
